// Convex client for the plasma restaurant portal.
//
// Stage F1 (Option A): the portal's single `ConvexReactClient` is now
// authenticated by vortex-auth. The vortex-auth runtime
// (`integrations/vortex-auth/runtime.tsx`) owns auth via `BetterAuthConvexProvider`
// -> `ConvexProviderWithAuth` -> `client.setAuth`, mirroring crm. There is no
// longer uses a provider-specific Convex wrapper here.
//
// This module now only constructs and exports the shared clients consumed by
// `main.tsx`, the TanStack Router context, and TanStack Query.
//
// NOTE: the former `MerchantInitializer` (login-time user/org
// sync) was deleted in F3 — server-side provisioning + onboarding handle that
// now.
import { ConvexQueryClient } from "@convex-dev/react-query";
import { ConvexReactClient } from "convex/react";

import { env } from "~/env";

export const convexClient = new ConvexReactClient(env.PUBLIC_CONVEX_URL);
export const convexQueryClient = new ConvexQueryClient(convexClient);
